import _DatabaseModel from "./_DatabaseModel";

class Risk extends _DatabaseModel {
  static model = "risk";

  static treatment_kind = [null, "reduce", "accept", "share"];
}

export default Risk;
